<div class="control-item-component">
  <div p-dialog-content style="width: 700px;">
    <div *ngIf="form" [formGroup]="form">
      <div class="form-grid grid">
        <div class="field col" style="width: 700px;">
          <label class="block font-bold mb-2" for="incidentNumber"
          >Incident #</label
          >
          <input
            inputId="incidentNumber"
            type="text"
            pInputText
            formControlName="incidentResponseNumber"
            class="w-full p-inputtext"
          />
        </div>
        <div class="field col" style="width: 700px;">
          <label class="block font-bold mb-2" for="name"
          >Name</label
          >
          <input
            inputId="name"
            type="text"
            pInputText
            formControlName="name"
            class="w-full p-inputtext"
          />
        </div>
        <div class="field col">
          <label class="block font-bold mb-2" for="type">Incident Type</label>
          <p-select
            inputId="type"
            formControlName="type"
            [options]="types"
            placeholder="Select a Type"
            appendTo="body"
          ></p-select>
        </div>
      </div>

      <div class="form-grid grid">
        <div class="field col">
          <label for="occurredDate" class="block font-bold mb-2"
            >Date Occurred</label
          >
          <p-datepicker
            inputId="occurredDate"
            formControlName="occuredDate"
            showIcon="true"
            dataType="string"
            dateFormat="mm/dd/yy"
          >
          </p-datepicker>
        </div>
        <div class="field col">
          <label for="reportedDate" class="block font-bold mb-2"
            >Reported Date</label
          >
          <p-datepicker
            inputId="reportedDate"
            formControlName="reportedDate"
            showIcon="true"
            dataType="string"
            dateFormat="mm/dd/yy"
          />
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <label for="severityLevel" class="block font-bold mb-2"
            >Severity Level</label
          >
          <input
            inputId="severityLevel"
            type="text"
            pInputText
            formControlName="severityLevel"
            class="w-full p-inputtext"
          />
        </div>
        <div class="field col">
          <label for="reportedBy" class="block font-bold mb-2"
            >Reported By</label
          >
          <input
            inputId="reportedBy"
            type="text"
            pInputText
            formControlName="reportedBy"
            class="w-full p-inputtext"
          />
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <label for="approver1Id" class="block font-bold mb-2">Approver 1</label>
          <p-select formControlName="approver1Id" appendTo="body" [options]="users" optionValue="userId" optionLabel="fullName"></p-select>
          <div *ngIf="incidentResponse?.approved1Date">Approved on {{incidentResponse.approved1Date | date: 'shortDate'}} {{incidentResponse.approved1Date | date: 'shortTime'}}</div>
        </div>
        <div class="field col" *ngIf="form.controls.approver1Id.value === currentUserId">
          <label for="isApproved1" class="block font-bold mb-2">Approved</label>
          <p-checkbox formControlName="isApproved1" [binary]="true">Approved</p-checkbox>
        </div>
        <div class="field col">
          <label for="approver2Id" class="block font-bold mb-2">Approver 2</label>
          <p-select formControlName="approver2Id" appendTo="body" [options]="users" optionValue="userId" optionLabel="fullName"></p-select>
          <div *ngIf="incidentResponse?.approved2Date">Approved on {{incidentResponse.approved2Date | date: 'shortDate'}} {{incidentResponse.approved2Date | date: 'shortTime'}}</div>
        </div>
        <div class="field col" *ngIf="form.controls.approver2Id.value === currentUserId">
          <label for="isApproved2" class="block font-bold mb-2">Approved</label>
          <p-checkbox formControlName="isApproved2" [binary]="true">Approved</p-checkbox>
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <label for="systemsAndServicesImpacted" class="block font-bold mb-2"
            >Systems & Services Impacted</label
          >
          <input
            inputId="systemsAndServicesImpacted"
            type="text"
            pInputText
            formControlName="systemsAndServicesImpacted"
            class="w-full p-inputtext"
          />
        </div>
        <div class="field col flex align-content-end justify-content-end">
          <div class="align-self-end">
            <p-button
              icon="pi pi-download"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="generateReport(incidentResponse.incidentResponseId)"
            ></p-button>
          </div>
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end">Initial Reporting</label>
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="
                visibility.initialReporting = !visibility.initialReporting
              "
            >
              <ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.initialReporting"
            [innerHTML]="
              addToken(form.controls.initialReporting.value) | sanitizeHtml
            "
          ></div>
          <p-editor
            *ngIf="visibility.initialReporting"
            type="text"
            name="references"
            formControlName="initialReporting"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end"
              >Incident Sequence of Events</label
            >
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="
                visibility.incidentSequenceOfEvents =
                  !visibility.incidentSequenceOfEvents
              "
            >
              <ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.incidentSequenceOfEvents"
            [innerHTML]="
              addToken(form.controls.incidentSequenceOfEvents.value)
                | sanitizeHtml
            "
          ></div>
          <p-editor
            *ngIf="visibility.incidentSequenceOfEvents"
            type="text"
            name="references"
            formControlName="incidentSequenceOfEvents"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end">Incident Mitigation</label>
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="
                visibility.incidentMitigation = !visibility.incidentMitigation
              "
            >
              <ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.incidentMitigation"
            [innerHTML]="
              addToken(form.controls.incidentMitigation.value) | sanitizeHtml
            "
          ></div>
          <p-editor
            *ngIf="visibility.incidentMitigation"
            type="text"
            name="references"
            formControlName="incidentMitigation"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end">Documentation</label>
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="visibility.documentation = !visibility.documentation"
            >
              <ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.documentation"
            [innerHTML]="
              addToken(form.controls.documentation.value) | sanitizeHtml
            "
          ></div>
          <p-editor
            *ngIf="visibility.documentation"
            type="text"
            name="references"
            formControlName="documentation"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
      </div>
      <div class="form-grid grid">
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end">Recommendations</label>
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="visibility.recommendations = !visibility.recommendations"
              ><ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.recommendations"
            [innerHTML]="
              addToken(form.controls.recommendations.value) | sanitizeHtml
            "
          ></div>
          <p-editor
            *ngIf="visibility.recommendations"
            type="text"
            name="references"
            formControlName="recommendations"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
        <div class="field col">
          <div class="flex align-content-center align-items-center gap-2">
            <label class="font-bold align-self-end"
              >Additional Comments/Notes</label
            >
            <p-button
              [rounded]="true"
              [text]="true"
              severity="secondary"
              (click)="
                visibility.additionalCommentsNotes =
                  !visibility.additionalCommentsNotes
              "
              ><ng-template pTemplate="icon">
                <span
                  class="pi pi-pencil"
                  style="font-size: 1rem"
                ></span> </ng-template
            ></p-button>
          </div>
          <div
            class="ql-editor"
            *ngIf="!visibility.additionalCommentsNotes"
            [innerHTML]="
              addToken(form.controls.additionalCommentsNotes.value)
                | sanitizeHtml
            "
          ></div>
          <p-editor
            matInput
            *ngIf="visibility.additionalCommentsNotes"
            type="text"
            name="references"
            formControlName="additionalCommentsNotes"
          >
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>
                <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button
                  aria-label="Document"
                  class="custom-button"
                  style="font-size: 1.3em; margin-top: -3px"
                  #el
                  (click)="selectDocument(el)"
                >
                  D
                </button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
      </div>
    </div>
    <div *ngIf="incidentResponse && incidentResponse.incidentResponseId">
      <div class="form-grid grid">
        <div class="field col">
          <p-table
            *ngIf="form.value.attachments"
            [value]="form.value.attachments"
            #table
            styleClass="risk-table-striped"
          >
            <ng-template pTemplate="caption">
              <div class="flex">
                <label class="block font-bold">Attachments</label>
                <label for="fileBlob" class="btn ml-auto p-0" matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                  <i class="pi pi-plus"></i>
                  <input
                    id="fileBlob"
                    type="file"
                    accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                    (change)="AddAssessmentAttachment($event)"
                    name="addAttachedFile3"
                    style="display: none"
                  />
                </label>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th
                  class="font-bold white-space-nowrap"
                  *ngFor="let col of attachmentCols"
                  [pSortableColumn]="col.field"
                  [ngStyle]="{ 'width': col.width || 'auto' }"
                >
                  {{ col.header }}
                </th>
                <th style="width: 3rem"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-file>
              <tr [pSelectableRow]="file">
                <td>
                  {{ file.date | date : 'shortDate' }}
                </td>
                <td>
                  <span
                    (click)="DownloadAttachment(file.internalName)"
                    class="btn btn-link"
                    >{{ file.name }}</span
                  >
                </td>
                <td>
                  <p-button
                    [text]="true"
                    icon="pi pi-trash"
                    severity="danger"
                    (click)="deleteAssessmentAttachment(item, file)"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</div>
<div class="p-dialog-footer flex gap-2 justify-content-end">
  <p-button label="Save" outlined="true" (click)="onSave()"></p-button>
  <p-button
    label="Save as New"
    severity="info"
    outlined="true"
    (click)="onSave(true)"
  >
  </p-button>
  <p-button
    label="Cancel"
    outlined="true"
    severity="secondary"
    (click)="onClose()"
  ></p-button>
</div>
